import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { ConnectionLostBannerContainer } from '../components/connectionLostBannerContainer';
import { ConnectionLostModalContainer } from '../components/connectionLostModalContainer';
import { LayoutModeChangeHandler } from '../components/layoutModeChangeHandler';
import { DEFAULT_FONT_FAMILY } from '../constants/constants';
import { useAppSelector } from '../redux/store';
import { SceneBeforeUnloadContainer } from '../scenes/sceneBeforeUnloadContainer';
import { SceneRouter } from '../scenes/sceneRouter';
import { TransitionAnimationContainer } from '../scenes/transitions/animations/transitionAnimationContainer';
export const SceneWrapper = ({ widthRatio, heightRatio }) => {
    const sceneType = useAppSelector((state) => state.scene.sceneType);
    const containerCss = useMemo(() => css(css `
          width: ${100 * widthRatio}vw;
          height: ${100 * heightRatio}vh;
          /* "GLOBAL" styles: */
          font-family: ${DEFAULT_FONT_FAMILY}, sans-serif;
          overflow-x: hidden;
        `, sceneType !== 'entry' &&
        css `
            /* Prevent double scrollbar... scrolling should only be enabled on entry page: */
            overflow-y: hidden;
          `), [widthRatio, heightRatio, sceneType]);
    return (_jsxs("div", { css: containerCss, children: [_jsx(TransitionAnimationContainer, {}), _jsx(SceneRouter, {}), _jsx(SceneBeforeUnloadContainer, {}), _jsx(ConnectionLostModalContainer, {}), _jsx(ConnectionLostBannerContainer, {}), _jsx(LayoutModeChangeHandler, {})] }));
};
